import { useAxios } from '@/context/axiosContext'
import '../blogBoard.css'
import GGOOLLFF from '@/assets/images/thumbnaillogo500px.png'
import { useLocation, useNavigate } from 'react-router-dom'
import { useEffect, useRef, useState } from 'react'
import { useDialog } from '@/context/dialogContext'
import {
  getBadgeLabel,
  GetBoardData,
  getMobileBadgeClass,
  searchMessages,
  withDrawnCumtomer,
} from '@/pages/board/boardItem'
import { BlogListItem, removeHtmlTags } from '../blogItem'
import commonUtils from '@/utils/commonUtils'
import Pagination from '@/pages/board/_components/pagination'
import { BoardSearch } from '@/pages/board/_components/boardSearch'
import { useResponsive } from '@/hooks/useResponsive'
import { BoardSearchMobile } from '@/pages/board/_components/boardSearchMobile'

type TInput = HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement

const BlogBoardList: React.FC = () => {
  const axios = useAxios()
  const location = useLocation()
  const navigate = useNavigate()
  const { showAlert } = useDialog()
  const [page, setPage] = useState(location.state?.page ?? 1) //null 또는 undefined일 때만 1이 기본값으로 설정
  const [pageCount, setPageCount] = useState(0) //페이지 count
  const [boardList, setBoardList] = useState<BlogListItem[]>([])
  const [fileSeqList, setFileSeqList] = useState<string[]>([])
  const [thumbnailList, setThumbnail] = useState<string[]>([])
  // 스크롤 위치 참조를 위한 ref 추가
  const containerRef = useRef<HTMLDivElement>(null)
  const filePath = process.env.REACT_APP_BASE_URL + '/upload'
  const [srchData, setSrchData] = useState({
    srchOpt: location.state?.srchOpt || '01',
    srchStr: location.state?.srchStr || '',
  })
  const { isMobile, isTablet, isDesktop } = useResponsive()

  useEffect(() => {
    getBlogBoardList()
    scrollToTop()
  }, [page])

  const handlePageChange = (page: number) => {
    setPage(page)
  }

  // 검색 버튼 클릭 시 또는 Enter 키 입력 시 getBoardList 실행
  const handleSearchSubmit = () => {
    getBlogBoardList()
    scrollToTop()
  }

  const scrollToTop = () => {
    // if (containerRef.current) {
    //   containerRef.current.scrollIntoView({
    //     behavior: 'smooth',
    //     block: 'start',
    //   })
    // } else {
    //   window.scrollTo({
    //     top: 0,
    //     behavior: 'smooth',
    //   })
    // }
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // 부드럽게 스크롤
    })
  }
  const getBlogBoardList = async () => {
    try {
      const data: GetBoardData = {
        srchOpt: srchData.srchOpt,
        srchStr: srchData.srchStr,
        page: page,
      }

      const response = await axios.get(`/blog/list`, {
        headers: { 'Cache-Control': 'no-cache' },
        params: { ...data },
      })

      const { blogList, pageCnt, thumbnailList, fileSeqList } =
        response.data.data

      if (Array.isArray(blogList)) {
        setBoardList(blogList)
        setFileSeqList(fileSeqList)
      }
      setPageCount(pageCnt)
      setThumbnail(thumbnailList)
    } catch (err: any) {
      console.error('Error fetching List:', err)
    }
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      getBlogBoardList()
    }
  }

  const handleSearch = (e: React.ChangeEvent<TInput>) => {
    const { name, value } = e.target as HTMLInputElement | HTMLTextAreaElement // 타입 캐스팅
    setSrchData((prev) => ({ ...prev, [name]: value }))
  }

  const handleDetailView = (nttSn: number) => {
    navigate(`/blog/detail?nttSn=${nttSn}`, { state: fileSeqList })
  }

  return (
    <>
      {/* <div className="album-board" ref={containerRef}>
        {boardList.length > 0 ? (
          boardList.map((item) => (
            <div
              className="album-item"
              key={item.nttSn}
              onClick={() => handleDetailView(item.nttSn)}
            >
              {item.thumbnailUrl ? (
                <img
                  src={filePath + item.thumbnailUrl}
                  className="album-image"
                  alt="thumbnail"
                  onError={(e) => {
                    e.currentTarget.onerror = null
                    e.currentTarget.src = GGOOLLFF
                  }}
                />
              ) : (
                <img src={GGOOLLFF} className="album-image" alt="이미지 제목" />
              )}
              <div className="album-divider" />
              <div className="title-with-count">
                <div
                  className="album-title"
                  title={item.nttSj}
                >{`${removeHtmlTags(item.nttSj)}`}</div>
                <div className="answer-count">{`${item.answerCnt !== 0 ? ` [${item.answerCnt}]` : ''}`}</div>
              </div>
              <div className="post-meta">
                <div className="author-section">
                  <span>작성자 :&nbsp;</span>
                  <span>
                    {item.withDrawYn ? withDrawnCumtomer.name : item?.nickName}
                  </span>
                </div>
                <div className="post-meta-divider" />
                <div className="post-meta-item">
                  작성일 :&nbsp;
                  {item?.regDate
                    ? commonUtils.formatDate(item.regDate, false)
                    : ''}
                </div>
                <div className="post-meta-divider" />
                <div className="post-meta-item">조회 : {item?.readngCnt}</div>
              </div>
            </div>
          ))
        ) : (
          <div className="no-results">
            <img src={GGOOLLFF} width={'200px'} />
            <div>아직 등록된 내용이 없거나, 찾으시는 결과가 없어요.</div>
          </div>
        )}
      </div> */}
      <div
        className="album-container"
        style={{ marginTop: !isMobile ? '20px' : '0' }}
      >
        <div className="album-wrapper">
          {/* <div className="album-header">
            <div>
              <h1 className="album-title">소통</h1>
              <p className="album-count">
                총 {boardList.length}개의 게시물 (페이지 {page}/{pageCount})
              </p>
            </div>

            <div className="album-controls">
              <input
                type="text"
                placeholder="게시물 검색..."
                //value={searchTerm}
                //onChange={(e) => handleSearch(e.target.value)}
                className="search-input"
              />
              <button className="write-button">글쓰기</button>
            </div>
          </div> */}

          {/* 앨범 그리드 */}
          {boardList.length > 0 ? (
            <>
              <div className="album-board">
                {boardList.map((item, index) => (
                  <div
                    key={item.nttSn}
                    className="album-item"
                    style={{ animationDelay: `${index * 0.1}s` }}
                    onClick={() => handleDetailView(item.nttSn)}
                  >
                    {/* 이미지 컨테이너 */}
                    <div className="image-container">
                      {item.thumbnailUrl ? (
                        <img
                          src={filePath + item.thumbnailUrl}
                          className="album-image"
                          alt="thumbnail"
                          onError={(e) => {
                            e.currentTarget.onerror = null
                            e.currentTarget.src = GGOOLLFF
                          }}
                        />
                      ) : (
                        <img
                          src={GGOOLLFF}
                          className="album-image"
                          alt="이미지 제목"
                        />
                      )}

                      {/* 조회수 배지 */}
                      {/* <div className="view-count">{item.readngCnt}</div> */}
                    </div>

                    {/* 콘텐츠 */}
                    <div className="album-content">
                      <div className="title-with-count">
                        <span
                          className={getMobileBadgeClass(item?.bbsSj || '00')}
                        >
                          {getBadgeLabel(item?.bbsSj ?? '기타')}
                        </span>
                        <h3 className="content-title">
                          &nbsp;&nbsp;{item.nttSj}
                        </h3>
                        {(item.answerCnt ?? 0) > 0 && (
                          <span className="answer-count">{item.answerCnt}</span>
                        )}
                      </div>

                      <div className="post-meta">
                        <span className="author-section">{item.nickName}</span>
                        <div className="post-meta-divider" />
                        <span>
                          {commonUtils.formatDate(item?.regDate ?? '', false)}
                        </span>
                        <div className="post-meta-divider" />
                        <span>views&nbsp;{item.readngCnt}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          ) : (
            <div className="no-results">
              <div className="no-results-icon">🔍</div>
              <h3 className="no-results-title">검색 결과가 없습니다</h3>
              <p className="no-results-text">다른 키워드로 검색해보세요</p>
            </div>
          )}
        </div>
      </div>
      {/* {!isMobile && (
        <div style={{ marginTop: '10px' }}>
          <BoardSearch
            handleSearch={handleSearch}
            handleSearchSubmit={handleSearchSubmit}
            handleKeyDown={handleKeyDown}
            srchData={srchData}
          />
        </div>
      )} */}
      {!isMobile ? (
        <div style={{ marginTop: '10px' }}>
          <BoardSearch
            handleSearch={handleSearch}
            handleSearchSubmit={handleSearchSubmit}
            handleKeyDown={handleKeyDown}
            srchData={srchData}
          />
        </div>
      ) : (
        <BoardSearchMobile
          handleSearch={handleSearch}
          handleSearchSubmit={handleSearchSubmit}
          handleKeyDown={handleKeyDown}
          srchData={srchData}
        />
      )}
      {pageCount > 0 && (
        <Pagination
          totalCount={pageCount}
          onPageChange={handlePageChange}
          paramPage={page || 1}
          boardType={'blog'}
        />
      )}
    </>
  )
}

export default BlogBoardList
